import React, { useEffect } from 'react'
import Routes from './Routes'
import { Route, Router } from 'react-router-dom'
import '../../scss/application.scss'
import history from 'browser-history'
import store from 'store'
import { Provider } from 'react-redux'
import * as chameleon from '@chamaeleonidae/chmln'

// Log runtime errors with sentry service
import 'sentry'

// Initialize fullstory analytics tracking
import 'fullstory'

// Initialize Datadog RUM monitoring
import 'datadog-rum'

// Top-level wrapper initializes redux and react-router.
function App() {
  useEffect(() => {
    chameleon.init(process.env.REACT_APP_CHAMELEON_PK, {
      fastUrl: 'https://fast.chameleon.io/',
    })
  }, [])
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route component={Routes} />
      </Router>
    </Provider>
  )
}

export default App
